import { request, success, failure, ATTENDANCE } from "./utilities";
import {
  employeeCheckInOrOut,
  shortLeaveRequest,
  lateCheckIn,
  getEmployeeTodayAttendance,
  getLeaveRequest,
  approveLeaveRequest,
  getEmployeesAttendance,
  getRecess,
  endRecess,
  gettingBreakTypes,
  markAttendance,
  getAttendanceReportByAdminApi,
} from "../api";
import { PostRequest } from "../api/genericApiCalls";
import { APP_SETTINGS } from "../../config";
import axios from "axios";

export function MarkAttendanceAction(reqObject, token, handleClose) {
  return (dispatch) => {
    dispatch(request(ATTENDANCE.MARK_ATTENDANCE_REQUEST));
    PostRequest(
      APP_SETTINGS.API_PATH.ATTENDANCE.markAttendance,
      reqObject,
      token
    ).then(
      (response) => {
        if (response.data.status === 1) {
          dispatch(
            success(ATTENDANCE.MARK_ATTENDANCE_SUCCESS, response.data.data)
          );
          if (handleClose) {
            handleClose({ status: 1 });
          }
        } else {
          dispatch(
            failure(ATTENDANCE.MARK_ATTENDANCE_FAILURE, response.data.message)
          );
          handleClose({ status: 0, error: response.data.message });
        }
      },
      (error) => {
        dispatch(
          failure(
            ATTENDANCE.EMPLOYEE_CHECK_IN_OR_OUT_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function CheckoutAction(token) {
  return (dispatch) => {
    dispatch(request(ATTENDANCE.CHECKOUT_REQUEST));
    PostRequest(APP_SETTINGS.API_PATH.ATTENDANCE.checkout, null, token).then(
      (response) => {
        if (response.data.status === 1) {
          dispatch(success(ATTENDANCE.CHECKOUT_SUCCESS, response.data.data));
        } else {
          dispatch(failure(ATTENDANCE.CHECKOUT_FAILURE, response.data.message));
        }
      },
      (error) => {
        dispatch(
          failure(
            ATTENDANCE.CHECKOUT_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function LeaveRequestAction(reqObject, token, moveToNext) {
  return (dispatch) => {
    dispatch(request(ATTENDANCE.LEAVE_REQUEST_REQUEST));
    PostRequest(
      APP_SETTINGS.API_PATH.ATTENDANCE.leaveRequest,
      reqObject,
      token
    ).then(
      (response) => {
        if (response.data.status === 1) {
          dispatch(
            success(ATTENDANCE.LEAVE_REQUEST_SUCCESS, response.data.data)
          );
          if (moveToNext) moveToNext(response);
        } else {
          dispatch(
            failure(ATTENDANCE.LEAVE_REQUEST_FAILURE, response.data.message)
          );
          if (moveToNext) moveToNext(response);
        }
      },
      (error) => {
        dispatch(
          failure(
            ATTENDANCE.LEAVE_REQUEST_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function ShortLeaveAction(reason, token) {
  return (dispatch) => {
    dispatch(request(ATTENDANCE.GET_SHORT_LEAVE_REQUEST));
    var path = `${APP_SETTINGS.API_PATH.ATTENDANCE.shortLeaveRequest}?reason=${reason}`;
    PostRequest(path, null, token).then(
      (response) => {
        if (response.data.status === 1) {
          dispatch(
            success(ATTENDANCE.GET_SHORT_LEAVE_SUCCESS, response.data.data)
          );
        } else {
          dispatch(
            failure(ATTENDANCE.GET_SHORT_LEAVE_FAILURE, response.data.message)
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            ATTENDANCE.GET_SHORT_LEAVE_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function TodayAttendanceSummaryAction(token) {
  return (dispatch) => {
    dispatch(request(ATTENDANCE.TODAY_ATTENDANCE_SUMMARY_REQUEST));
    PostRequest(
      APP_SETTINGS.API_PATH.ATTENDANCE.todayAttendanceSummary,
      null,
      token
    ).then(
      (response) => {
        if (response.data.status === 1) {
          dispatch(
            success(
              ATTENDANCE.TODAY_ATTENDANCE_SUMMARY_SUCCESS,
              response.data.data
            )
          );
        } else {
          dispatch(
            failure(
              ATTENDANCE.TODAY_ATTENDANCE_SUMMARY_FAILURE,
              response.data.message
            )
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            ATTENDANCE.TODAY_ATTENDANCE_SUMMARY_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function AttendanceSummaryAction(reqObject, token) {
  return (dispatch) => {
    dispatch(request(ATTENDANCE.ATTENDANCE_SUMMARY_REQUEST));
    PostRequest(
      APP_SETTINGS.API_PATH.ATTENDANCE.attendanceSummary,
      reqObject,
      token
    ).then(
      (response) => {
        if (response.data.status === 1) {
          dispatch(
            success(ATTENDANCE.ATTENDANCE_SUMMARY_SUCCESS, response.data.data)
          );
        } else {
          dispatch(
            failure(
              ATTENDANCE.ATTENDANCE_SUMMARY_FAILURE,
              response.data.message
            )
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            ATTENDANCE.ATTENDANCE_SUMMARY_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}
export function AttendanceReportAction(reqObject, token) {
  return (dispatch) => {
    dispatch(request(ATTENDANCE.ATTENDANCE_REPORT_REQUEST));
    PostRequest(
      APP_SETTINGS.API_PATH.ATTENDANCE.attendanceReport,
      reqObject,
      token
    ).then(
      (response) => {
        // console.log('attendance report', response)
        if (response.data.status === 1) {
          dispatch(
            success(ATTENDANCE.ATTENDANCE_REPORT_SUCCESS, response.data.data)
          );
        } else {
          dispatch(
            failure(ATTENDANCE.ATTENDANCE_REPORT_FAILURE, response.data.message)
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            ATTENDANCE.ATTENDANCE_REPORT_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function LeaveRequestsListAction(reqObject, token) {
  return (disapatch) => {
    disapatch(request(ATTENDANCE.LEAVE_REQUEST_LIST_REQUEST));
    PostRequest(
      APP_SETTINGS.API_PATH.ATTENDANCE.leaveRequests,
      reqObject,
      token
    ).then(
      (response) => {
        // console.log('response :::', response);
        if (response.data.status === 1) {
          disapatch(
            success(ATTENDANCE.LEAVE_REQUEST_LIST_SUCCESS, response.data.data)
          );
        } else {
          disapatch(
            failure(
              ATTENDANCE.LEAVE_REQUEST_LIST_FAILURE,
              response.data.message
            )
          );
        }
      },
      (error) => {
        disapatch(
          failure(
            ATTENDANCE.LEAVE_REQUEST_LIST_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function LeaveApprovalAction(reqObject, handleClose, info, token) {
  return (dispatch) => {
    dispatch(request(ATTENDANCE.LEAVE_APPROVAL_REQUEST));
    PostRequest(
      APP_SETTINGS.API_PATH.ATTENDANCE.leaveApproval,
      reqObject,
      token
    ).then(
      (response) => {
        if (response.data.status === 1) {
          dispatch(success(ATTENDANCE.LEAVE_APPROVAL_SUCCESS, response, info));
          if (handleClose) {
            handleClose();
          }
        } else {
          dispatch(
            failure(ATTENDANCE.LEAVE_APPROVAL_FAILURE, response.data.message)
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            ATTENDANCE.LEAVE_APPROVAL_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function DailytAttendanceListAction(reqObject, token) {
  return (dispatch) => {
    dispatch(request(ATTENDANCE.DAILY_ATTENDANCE_REQUEST));
    PostRequest(
      APP_SETTINGS.API_PATH.ATTENDANCE.dailyAttendanceList,
      reqObject,
      token
    ).then(
      (response) => {
        if (response.data.status === 1) {
          dispatch(
            success(ATTENDANCE.DAILY_ATTENDANCE_SUCCESS, response.data.data)
          );
        } else {
          dispatch(
            failure(ATTENDANCE.DAILY_ATTENDANCE_FAILURE, response.data.message)
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            ATTENDANCE.DAILY_ATTENDANCE_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function NextDailytAttendanceListAction(reqObject, token) {
  return (dispatch) => {
    dispatch(request(ATTENDANCE.NEXT_DAILY_ATTENDANCE_REQUEST));
    PostRequest(
      APP_SETTINGS.API_PATH.ATTENDANCE.dailyAttendanceList,
      reqObject,
      token
    ).then(
      (response) => {
        if (response.data.status === 1) {
          dispatch(
            success(
              ATTENDANCE.NEXT_DAILY_ATTENDANCE_SUCCESS,
              response.data.data
            )
          );
        } else {
          dispatch(
            failure(ATTENDANCE.DAILY_ATTENDANCE_FAILURE, response.data.message)
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            ATTENDANCE.DAILY_ATTENDANCE_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function FilterDailytAttendanceListAction(reqObject, token) {}

export function lateCheckInAction(data, token, LeaveRequestActionCallBack) {
  return (dispatch) => {
    dispatch(request(ATTENDANCE.LATE_CHECK_IN_REQUEST));
    lateCheckIn(data, token).then(
      (response) => {
        if (response.data.status === 1) {
          dispatch(
            success(ATTENDANCE.LATE_CHECK_IN_SUCCESS, response.data.data)
          );
        } else {
          dispatch(
            failure(ATTENDANCE.LATE_CHECK_IN_FAILURE, response.data.message)
          );
        }
        if (LeaveRequestActionCallBack) {
          LeaveRequestActionCallBack(response.data);
        }
      },
      (error) => {
        dispatch(
          failure(
            ATTENDANCE.LATE_CHECK_IN_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function CheckAttendanceStatus(token, setMarkAttendance) {
  return (dispatch) => {
    // console.log('called');
    dispatch(request(ATTENDANCE.GET_EMPLOYEE_TODAY_ATTENDANCE_REQUEST));
    PostRequest(
      APP_SETTINGS.API_PATH.ATTENDANCE.getEmployeeTodayAttendance,
      null,
      token
    ).then(
      (response) => {
        if (response.data.status === 1) {
          dispatch(
            success(
              ATTENDANCE.GET_EMPLOYEE_TODAY_ATTENDANCE_SUCCESS,
              response.data.data
            )
          );
          // if (
          //   response.data.message !== "Attendance status retrieved successfully"
          // ) {
          //   setMarkAttendance(true);
          // }
        } else {
          dispatch(
            failure(
              ATTENDANCE.GET_EMPLOYEE_TODAY_ATTENDANCE_FAILURE,
              response.data.message
            )
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            ATTENDANCE.GET_EMPLOYEE_TODAY_ATTENDANCE_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function getLeaveRequestAction() {
  return (dispatch) => {
    dispatch(request(ATTENDANCE.GET_LEAVE_REQUEST));
    getLeaveRequest().then(
      (response) => {
        if (response.data.status === 1) {
          dispatch(success(ATTENDANCE.GET_LEAVE_SUCCESS, response.data.data));
        } else {
          dispatch(
            failure(ATTENDANCE.GET_LEAVE_FAILURE, response.data.message)
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            ATTENDANCE.GET_LEAVE_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}
export function getAttendanceReportByAdminAction(data) {
  return (dispatch) => {
    dispatch(request(ATTENDANCE.GET_ATTENDANCE_BY_ADMIN_REPORT_REQUEST));
    getAttendanceReportByAdminApi(data).then(
      (response) => {
        if (response.data.status === 200) {
          dispatch(
            success(
              ATTENDANCE.GET_ATTENDANCE_BY_ADMIN_REPORT_SUCCESS,
              response.data.data
            )
          );
        } else {
          dispatch(
            failure(
              ATTENDANCE.GET_ATTENDANCE_BY_ADMIN_REPORT_FAILURE,
              response.data.message
            )
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            ATTENDANCE.GET_ATTENDANCE_BY_ADMIN_REPORT_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function approveLeaveRequestAction() {
  return (dispatch) => {
    dispatch(request(ATTENDANCE.APPROVE_LEAVE_REQUEST));
    approveLeaveRequest().then(
      (response) => {
        if (response.data.status === 1) {
          dispatch(
            success(ATTENDANCE.APPROVE_LEAVE_SUCCESS, response.data.data)
          );
        } else {
          dispatch(
            failure(ATTENDANCE.APPROVE_LEAVE_FAILURE, response.data.message)
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            ATTENDANCE.APPROVE_LEAVE_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function getEmployeesAttendanceAction() {
  return (dispatch) => {
    dispatch(request(ATTENDANCE.GET_EMPLOYEES_ATTENDANCE_REQUEST));
    getEmployeesAttendance().then(
      (response) => {
        if (response.data.status === 1) {
          dispatch(
            success(
              ATTENDANCE.GET_EMPLOYEES_ATTENDANCE_SUCCESS,
              response.data.data
            )
          );
        } else {
          dispatch(
            failure(
              ATTENDANCE.GET_EMPLOYEES_ATTENDANCE_FAILURE,
              response.data.message
            )
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            ATTENDANCE.GET_EMPLOYEES_ATTENDANCE_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function ShortBreakAction(reqObject, token) {
  return (dispatch) => {
    dispatch(request(ATTENDANCE.SHORT_BREAK_REQUEST));
    PostRequest(
      APP_SETTINGS.API_PATH.ATTENDANCE.shortBreak,
      reqObject,
      token
    ).then(
      (response) => {
        if (response.data.status === 1) {
          dispatch(success(ATTENDANCE.SHORT_BREAK_SUCCESS, response.data.data));
        } else {
          dispatch(
            failure(ATTENDANCE.SHORT_BREAK_FAILURE, response.data.message)
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            ATTENDANCE.SHORT_BREAK_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function endBreak(data, token) {
  return (dispatch) => {
    dispatch(request(ATTENDANCE.END_BREAK_REQUEST));
    endRecess(data, token).then(
      (response) => {
        // console.log("respones::", response);
        if (response.data.status === 1) {
          dispatch(success(ATTENDANCE.END_BREAK_SUCCESS, data.requestId));
        } else {
          dispatch(
            failure(ATTENDANCE.END_BREAK_FAILURE, response.data.message)
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            ATTENDANCE.END_BREAK_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function getBreakTypes(token) {
  return (dispatch) => {
    dispatch(request(ATTENDANCE.GET_BREAK_TYPES_REQUEST));
    gettingBreakTypes(token).then(
      (response) => {
        // console.log("breaktypes::", response);
        if (response.data.status === 1) {
          dispatch(
            success(ATTENDANCE.GET_BREAK_TYPES_SUCCESS, response.data.data)
          );
        } else {
          dispatch(
            failure(ATTENDANCE.GET_BREAK_TYPES_FAILURE, response.data.message)
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            ATTENDANCE.GET_BREAK_TYPES_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function EmployeMarkAttendance(reqObject, token, moveToNext) {
  return (dispatch) => {
    dispatch(request(ATTENDANCE.MARK_ATTENDANCE_REQUEST));
    markAttendance(reqObject, token).then(
      (response) => {
        if (response.data.status === 1) {
          dispatch(
            success(ATTENDANCE.MARK_ATTENDANCE_SUCCESS, response.data.data)
          );
          if (moveToNext) {
            moveToNext(response);
          }
        } else {
          dispatch(
            failure(ATTENDANCE.MARK_ATTENDANCE_FAILURE, response.data.message)
          );
          if (moveToNext) {
            moveToNext(response);
          }
        }
      },
      (error) => {
        dispatch(
          failure(
            ATTENDANCE.EMPLOYEE_CHECK_IN_OR_OUT_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}
